export default function UserCircleIcon(
  props: Readonly<React.SVGProps<SVGSVGElement>>,
) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.0003 9.99972C11.381 9.99972 12.5003 8.88044 12.5003 7.49972C12.5003 6.11901 11.381 4.99972 10.0003 4.99972C8.61962 4.99972 7.50033 6.11901 7.50033 7.49972C7.50033 8.88044 8.61962 9.99972 10.0003 9.99972Z"
        stroke="currentColor"
        strokeWidth="1.25528"
      />
      <path
        d="M9.99969 18.3329C14.6021 18.3329 18.333 14.602 18.333 9.99961C18.333 5.39724 14.6021 1.66628 9.99969 1.66628C5.39732 1.66628 1.66636 5.39724 1.66636 9.99961C1.66636 14.602 5.39732 18.3329 9.99969 18.3329Z"
        stroke="currentColor"
        strokeWidth="1.25528"
      />
      <path
        d="M14.9742 16.6662C14.8416 14.2566 14.1039 12.4995 9.99989 12.4995C5.89598 12.4995 5.15823 14.2566 5.0256 16.6662"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
    </svg>
  );
}
